__webpack_require__.p = "/wp-content/themes/vsao-sg/dist/";